export default "__VITE_ASSET__CAAFl39F__"